import ListItem from "components/CRM/ListItem";
import { getUserCloudPermissions } from "utils/UserUtils";
import { Container, Modal, ModalBody } from "reactstrap";
import useUser from "api/api-hooks/auth/useUser";
import UsersCloudOptions from "../../../components/Options/UsersCloudOptions";
import { AppConfirm } from "utils/PopupUtil";
import { AppInputConfirm } from "utils/PopupUtil";
import AppSpinner from "../../../elements/AppSpinner";
import useDeleteCloud from "../../../api/api-hooks/cloud/useDeleteCloud";
import useRemoveUser from "../../../api/api-hooks/tenantUsers/useRemoveUser";
import { useAtomValue } from "jotai";
import { tenantAtom } from "../../../atoms/GlobalAtoms";
import { useNavigate } from "react-router-dom";

const AccountClouds = () => {
  const { user, cPermissions: permissions } = useUser();
  const { deleteCloud, deletingCloud, deleteCloudError } = useDeleteCloud();
  const { removeUser } = useRemoveUser();
  const tenant = useAtomValue(tenantAtom);
  const navigate = useNavigate();

  const handleLeave = async (cloud) => {
    await removeUser({
      user: user,
      supportTargetCloudID: cloud?.TenantID,
      leaveCloud: true,
      onSuccess: () => {
        if (tenant.TenantID === cloud?.TenantID) {
          navigate("/clouds");
        }
      },
    });
  };

  const handleDelete = async (cloud) => {
    let result = await AppConfirm({
      title: "Delete Cloud?",
      text: "If you delete this cloud you and ALL users will lose access to all workspaces and pages inside this cloud. You cannot undo this action.",
      confirmButtonText: "Delete Cloud",
    });

    if (!result.isConfirmed) return;

    result = await AppInputConfirm({
      title: "Confirm Deletion",
      html: `<p>Enter the clouds name to confirm deletion.</p><p class="text-dark" style="font-weight: 600;"><b>${cloud?.TenantName}</b></p>`,
      deleteValue: cloud?.TenantName,
      confirmButtonText: "Delete Cloud",
    });

    if (!result.isConfirmed) return;

    deleteCloud({ cloudID: cloud?.TenantID });
  };

  return (
    <>
      <Container fluid>
        <div className="px-3">
          <h3 className="mb-0">Your Clouds</h3>
          <div>
            <small>
              This is a list of the all the clouds you have access to.
            </small>
          </div>
          <hr className="mt-2 mb-3"></hr>
          {!user ? (
            <>
              <ListItem loading={true} />
              <ListItem loading={true} />
            </>
          ) : (
            user.Tenants.map((cloud) => {
              const permissionProfile = getUserCloudPermissions(
                user,
                permissions,
                cloud?.TenantID
              );

              return (
                <ListItem
                  key={cloud?.TenantID}
                  title={cloud?.TenantName || cloud?.TenantID}
                  icon="mdi-cloud"
                  iconColor="var(--primary)"
                  badgeTitle={permissionProfile?.Name}
                  badgeColor="secondary"
                  options={
                    <UsersCloudOptions
                      user={user}
                      cloud={cloud}
                      onLeave={handleLeave}
                      onDelete={handleDelete}
                    />
                  }
                />
              );
            })
          )}
        </div>
      </Container>
      <Modal isOpen={deletingCloud} className="modal-dialog-centered">
        <ModalBody className="m-0 p-0">
          <div className="border border-superlight shadow-sm rounded d-flex flex-column align-items-center p-5">
            <h1 className="mb-4">Deleting Cloud...</h1>
            <AppSpinner
              style={{ height: "3.5rem", width: "3.5rem", fontSize: 25 }}
              className="mt-4 mb-5"
              size="xl"
            />
            <div style={{ fontWeight: 500 }} className="text-center">
              We're deleting your GrowthCloud instance. This will only take a
              minute or two.
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AccountClouds;
